/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  ChangeAhHeatPumpConfigBody,
  CMDReq,
} from '..';
import {
  serializeChangeAhHeatPumpConfigBody,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface ChangeAhHeatPumpConfigInput {
  loggerId: string;
  transactionId: string;
  body: ChangeAhHeatPumpConfigBody;
}
const build = (_query: DocumentNode, input: ChangeAhHeatPumpConfigInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.loggerId !== undefined ? `$loggerId: String = ${JSON.stringify(input.loggerId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.transactionId !== undefined ? `$transactionId: String = ${JSON.stringify(input.transactionId).replace(/"(\w+)":/g, '$1:')}, ` : '' ) + ``+
    ( input.body !== undefined ? `$body: ChangeAhHeatPumpConfigBody = ${serializeChangeAhHeatPumpConfigBody(input.body)}` : '' ) + `){
    changeAhHeatPumpConfig(
      ${ input.loggerId !== undefined ? 'loggerId: $loggerId,' : '' } 
      ${ input.transactionId !== undefined ? 'transactionId: $transactionId,' : '' } 
      ${ input.body !== undefined ? 'body: $body,' : '' }
    ){
      ...cmdreq
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class ChangeAhHeatPumpConfigMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment cmdreq on CMDReq { ... }
   */
  async execute(_query: DocumentNode, input: ChangeAhHeatPumpConfigInput): Promise<apollo.FetchResult< { changeAhHeatPumpConfig: Partial<CMDReq> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ changeAhHeatPumpConfig: Partial<CMDReq> }>({ mutation: build(_query, input) });
  }
}
